import { useQuery } from '@tanstack/react-query';
import { workspaceService } from '../services/workspace-service';

/**
 * Hook to fetch workspaces with aggressive caching
 * Workspaces rarely change, so we cache for a long time
 */
export function useWorkspaces(isEnabled: boolean = true) {
  return useQuery({
    queryKey: ['workspaces'],
    queryFn: () => workspaceService.getWorkspaces(),
    enabled: isEnabled,
    // Data considered fresh for 5 minutes - workspaces rarely change
    staleTime: 5 * 60 * 1000,
    // Keep in cache for 30 minutes
    gcTime: 30 * 60 * 1000,
    // Don't refetch on mount if data is fresh
    refetchOnMount: false,
    // Don't refetch on window focus
    refetchOnWindowFocus: false,
  });
}
